import type { SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement> & { size?: number };

function Svg({ size = 20, children, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {children}
    </svg>
  );
}

export const CalendarIcon = (props: IconProps) => (
  <Svg {...props}><rect x="3" y="5" width="18" height="16" rx="3"/><path d="M16 3v4M8 3v4M3 10h18"/></Svg>
);
export const BookIcon = (props: IconProps) => (
  <Svg {...props}><path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v16H6.5A2.5 2.5 0 0 0 4 21.5z"/><path d="M4 5.5v16M8 7h8M8 11h7"/></Svg>
);
export const BasketIcon = (props: IconProps) => (
  <Svg {...props}><path d="m6 10 3-6m9 6-3-6M3 10h18l-2 10H5z"/><path d="M9 14v2m6-2v2"/></Svg>
);
export const ChevronLeftIcon = (props: IconProps) => <Svg {...props}><path d="m15 18-6-6 6-6"/></Svg>;
export const ChevronRightIcon = (props: IconProps) => <Svg {...props}><path d="m9 18 6-6-6-6"/></Svg>;
export const ChevronDownIcon = (props: IconProps) => <Svg {...props}><path d="m6 9 6 6 6-6"/></Svg>;
export const PlusIcon = (props: IconProps) => <Svg {...props}><path d="M12 5v14M5 12h14"/></Svg>;
export const MinusIcon = (props: IconProps) => <Svg {...props}><path d="M5 12h14"/></Svg>;
export const XIcon = (props: IconProps) => <Svg {...props}><path d="m6 6 12 12M18 6 6 18"/></Svg>;
export const CheckIcon = (props: IconProps) => <Svg {...props}><path d="m5 12 4 4L19 6"/></Svg>;
export const CopyIcon = (props: IconProps) => <Svg {...props}><rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></Svg>;
export const DownloadIcon = (props: IconProps) => <Svg {...props}><path d="M12 3v12m0 0 4-4m-4 4-4-4M5 21h14"/></Svg>;
export const LinkIcon = (props: IconProps) => <Svg {...props}><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></Svg>;
export const EditIcon = (props: IconProps) => <Svg {...props}><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z"/></Svg>;
export const AlertIcon = (props: IconProps) => <Svg {...props}><path d="M10.3 3.7 2.4 17.5A2 2 0 0 0 4.1 20h15.8a2 2 0 0 0 1.7-2.5L13.7 3.7a2 2 0 0 0-3.4 0Z"/><path d="M12 9v4m0 3h.01"/></Svg>;
export const SparkleIcon = (props: IconProps) => <Svg {...props}><path d="m12 3-1 3.5L7.5 8l3.5 1.5 1 3.5 1.5-3.5L17 8l-3.5-1.5zM5 14l-.8 2.2L2 17l2.2.8L5 20l.8-2.2L8 17l-2.2-.8zM18.5 13l-.7 1.8-1.8.7 1.8.7.7 1.8.7-1.8 1.8-.7-1.8-.7z"/></Svg>;
export const UtensilsIcon = (props: IconProps) => <Svg {...props}><path d="M7 3v8M4 3v5a3 3 0 0 0 6 0V3M7 11v10M15 3v18M15 3c4 2 5 6 0 9"/></Svg>;
export const RefreshIcon = (props: IconProps) => <Svg {...props}><path d="M20 6v5h-5M4 18v-5h5"/><path d="M18.5 9A7 7 0 0 0 6 6.5L4 11m16 2-2 4.5A7 7 0 0 1 5.5 15"/></Svg>;
export const MoreIcon = (props: IconProps) => <Svg {...props}><circle cx="5" cy="12" r="1" fill="currentColor" stroke="none"/><circle cx="12" cy="12" r="1" fill="currentColor" stroke="none"/><circle cx="19" cy="12" r="1" fill="currentColor" stroke="none"/></Svg>;
export const SearchIcon = (props: IconProps) => <Svg {...props}><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/></Svg>;
